var _linearGradient, _linearGradient2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.395,
    x2: 423.014,
    y1: 370.606,
    y2: 88.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf6ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.606,
    x2: 454.776,
    y1: 486.395,
    y2: 57.225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5558ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c0ff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m317 45c-82.705 0-150 67.295-150 150s67.295 150 150 150 150-67.295 150-150-67.295-150-150-150zm-137.871 266.675-37.734 37.72c-5.859 5.859-5.859 15.352 0 21.211 5.859 5.86 15.352 5.859 21.211 0l37.734-37.72c5.859-5.859 5.859-15.352 0-21.211s-15.352-5.86-21.211 0z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m317 0c-107.402 0-195 87.599-195 195s87.598 195 195 195 195-87.599 195-195-87.598-195-195-195zm0 330c-74.399 0-135-60.601-135-135s60.601-135 135-135 135 60.601 135 135-60.601 135-135 135zm-175.605-1.816c-5.859-5.859-15.352-5.859-21.211 0l-115.789 115.789c-5.859 5.859-5.859 15.352 0 21.211l42.422 42.422c5.86 5.859 15.352 5.859 21.211 0l115.789-115.789c5.859-5.859 5.859-15.352 0-21.211z",
    fill: "url(#SVGID_2_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cd6dfdb409d58b69346d246e4e485f8c.svg";
export { ForwardRef as ReactComponent };